import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import '../../sass/components/flexibleModules/_components.fullWidthBannerOrPromoOrStatisticsSection.scss';

const FullWidthBannerOrPromoOrStatisticsSection = ({ data }) => {
    return (
        <div className={`cp-flexibleFullWidthBannerOrPromoOrStatisticsSection l-${data.promoBannerOrStatisticsSection} l-${data.textColor}`} style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-flexibleFullWidthBannerOrPromoOrStatisticsSection__inner" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                {data.promoBannerOrStatisticsSection === 'Statistics' ?
                    <div className="cp-statistics">
                        {data.statisticsHeader &&
                            <h2 dangerouslySetInnerHTML={{ __html: data.statisticsHeader }} />
                        }
                        {data.statisticsGridSections &&
                            <div className="cp-statistics__grid l--flex">
                                {data.statisticsGridSections.map((gridItems, index) => (
                                    <div className="cp-statistics__grid-section l--flex">
                                        <span className="l--divider" style={{ backgroundColor: gridItems.unitColorRepresentor }}></span>
                                        <span className="l--metrics">
                                            <h3 dangerouslySetInnerHTML={{ __html: gridItems.unitNumber }} />
                                            <span dangerouslySetInnerHTML={{ __html: gridItems.unitDetails }} />
                                        </span>
                                    </div>
                                ))}
                            </div>
                        }
                    </div>
                    :
                    <div className="cp-promo l--flex" style={{ backgroundColor: data.promoBannerBackgroundColor }}>
                        <h2 dangerouslySetInnerHTML={{ __html: data.promoBannerHeader }} />
                        {data.promoBannerButton &&
                            <a href={data.promoBannerButton.url} target={data.promoBannerButton.target} className="l-button">
                                <span>{data.promoBannerButton.title}</span>
                                <StaticImage src="../../images/arrow-right-white.svg" alt="" />
                            </a>
                        }
                    </div>
                }
            </div>
        </div>
    );
}

export default FullWidthBannerOrPromoOrStatisticsSection;